import * as yup from 'yup';
import { AuthReducer } from '../../redux/auth';
import { SecurityReducer } from '../../redux/security';
import store from '../../store/store';
import { CallAPI } from 'actions/General';

const AuthAction = AuthReducer.actions;
const SecurityAction = SecurityReducer.actions;
const dispatch = store.dispatch;

export const loginSchema = yup.object({
  email: yup.string().required('Email is required'),
  password: yup.string().required('Password is required'),
});

export const userLogin = async (data, setLoader, setApiError) => {
  // publicKey is appended automatically by the request interceptor for public
  // APIs (see axios/Axios.js) so the server can encrypt the response for us.
  const result = await CallAPI(
    'LOGIN_API',
    { email: data.email, password: await data.password },
    null,
    setLoader,
    setApiError,
    null,
  );
  console.log('result', result);
  if (result.status) {
    dispatch(
      AuthAction.updateAuthState({
        accessToken: result.data.token,
        accessRefreshToken: result.data.refreshToken,
      }),
    );
    // serverPrivateKey unlocks decryption of subsequent authenticated responses.
    dispatch(
      SecurityAction.updateSecurity({
        serverPrivateKey: result.data.serverPrivateKey,
      }),
    );
  }
};

export const updateRefreshToken = async () => {
  const result = await CallAPI('REFRESH_AUTH_TOKEN', null, null, null, null, null);
  console.log('result', result);
  if (result.status) {
    dispatch(
      AuthAction.updateAuthState({
        accessToken: result.data.token,
        accessRefreshToken: result.data.refreshToken,
      }),
    );
  }
};
